import { render, staticRenderFns } from "./FactoryQualityDashboard.vue?vue&type=template&id=4d645e1c&scoped=true&"
import script from "./FactoryQualityDashboard.vue?vue&type=script&lang=js&"
export * from "./FactoryQualityDashboard.vue?vue&type=script&lang=js&"
import style0 from "./FactoryQualityDashboard.vue?vue&type=style&index=0&id=4d645e1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d645e1c",
  null
  
)

export default component.exports